import { Route } from "react-router";
import { type ReactNode } from "react";

export function catchAll(path: string, element: ReactNode) {
  return (
    <Route path={path}>
      <Route path="*" element={element} />
      <Route index element={element} />
    </Route>
  );
}
